import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=411c56a6&lang=pug"
import script from "./ProvidersList.vue?vue&type=script&lang=js"
export * from "./ProvidersList.vue?vue&type=script&lang=js"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=411c56a6&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Address: require('/home/docker/code/frontend/components/Address.vue').default})
